import type { en } from "./en";

// Tigrinya translations. Missing keys fall back to English via i18next.
export const ti: typeof en = {
  common: {
    home: "መበገሲ",
    no_scores: "ገና ነጥቢ የለን",
    points_count_one: "{{count}} ነጥቢ",
    points_count_other: "{{count}} ነጥብታት",
    questions_count_one: "{{count}} ሕቶ",
    questions_count_other: "{{count}} ሕቶታት",
  },
  home: {
    placeholder: "ኮድ ጸወታ",
    enter: "እቶ",
    error_invalid_code: "እቲ ካብ መምህርካ ዝተዋህበካ ናይ 6-ፊደል ኮድ ጸወታ ኣእቱ።",
    footer: "Binogi Buzz ካብ ናይ Binogi.com ፍርያት ጀምር።",
    language_label: "ቋንቋ",
  },
  errors: {
    generic: "ገለ ጌጋ ኣጋጢሙ። በጃኻ እንደገና ፈትን።",
    stale_client: "እዚ ገጽ ኣረጊቱ ኣሎ — በጃኻ ኣሐድሶ።",
    session_not_found: "እዚ ክፍለ-ግዜ ኣይተረኽበን።",
    session_not_open: "እዚ ክፍለ-ግዜ ተወዲኡ።",
    session_not_active: "እዚ ሕቶ ወይ ክፍለ-ግዜ ድሮ ተወዲኡ።",
    not_teacher: "እዚ ክገብሮ ዝኽእል መምህር ጥራይ እዩ።",
    already_answered: "ነዚ ሕቶ ድሮ መሊስካዮ ኢኻ።",
    wrong_question_index: "እዚ ሕቶ ገና ኣይጀመረን።",
    name_taken: "እዚ ስም ድሮ ተወሲዱ። ካልእ ፈትን።",
    character_busy: "ሕጂ ገጸ-ባህሪ ክንህበካ ኣይከኣልናን — በጃኻ እንደገና ፈትን።",
  },
  host: {
    input: {
      heading: "Buzz ጀምር",
      lead:
        "እቲ ተምሃሮኻ ዝመሃርዎ ዘለዉ ኮድ ትምህርቲ Binogi ኣእቱ። ሕቶታቱ ጽዒንና ኣብ ሰሌዳ እትዝርግሖ ክፍለ-ግዜ ክንፈጥር ኢና።",
      lesson_code_label: "ኮድ ትምህርቲ",
      placeholder_code: "BIH750",
      load_button: "ትምህርቲ ጽዓን",
      try_hint: "ፈትን፥",
      error_invalid_code: "ኮድ ትምህርቲ Binogi ኣእቱ፣ ንኣብነት BIH750።",
      error_not_found: "ብኮድ {{code}} ዝኾነ ትምህርቲ ኣይተረኽበን።",
      error_unreachable: "ናብ ሰርቨር ትምህርቲ ምብጻሕ ኣይተኻእለን። ርክብካ ኣረጋግጽ እሞ እንደገና ፈትን።",
      error_no_questions: "ትምህርቲ {{code}} Buzz ክጥቀመሉ ዝኽእል ሕቶ የብሉን።",
      error_no_level_questions: "ትምህርቲ {{code}} ኣብቲ ዝተመርጸ ደረጃ ሕቶ የብሉን።",
    },
    loading: "ትምህርቲ ይጽዓን ኣሎ…",
    placeholder_title: "Binogi Buzz ጀምር",
    tab_details: "ዝርዝራት",
    tab_questions: "ሕቶታት",
    settings: "ምድላዋት",
    number_of_students: "ቁጽሪ ተምሃሮ",
    fewer_students: "ዝወሓዱ ተምሃሮ",
    more_students: "ዝበዝሑ ተምሃሮ",
    player_names: "ስም ተጻዋቲ",
    player_anonymous: "ብዘይ ስም",
    player_self_chosen: "ተምሃሮ ይምረጹ",
    language: "ቋንቋ",
    language_teacher: "መምህር ይመርጽ",
    language_students: "ተምሃሮ ይምረጹ",
    time_per_question: "ግዜ ኣብ ነፍሲ-ወከፍ ሕቶ",
    time_option: "{{seconds}} ካ",
    start_button: "ክፍለ-ግዜ ጀምር",
    start_disabled: "ንምጅማር ዓቐን ክፍሊ ኣእቱ",
    creating: "ክፍለ-ግዜ ይፍጠር ኣሎ…",
    error_no_questions: "ቅድሚ ምጅማር እንተወሓደ ሓደ ሕቶ ኣቐምጥ።",
    error_create_failed: "ምፍጣር ክፍለ-ግዜ ኣይተኻእለን",
    error_load_failed: "ምጽዓን ትምህርቲ ኣይተኻእለን",
    no_session: "ዝቕጽል ዘሎ ክፍለ-ግዜ የለን።",
    back_to_review: "ናብ ሕቶታት ተመለስ",
    errors: {
      dismiss: "ዕጾ",
      refresh: "ኣሐድስ",
      attach_failed: "እዚ ስክሪን ከም መምህር ክራኸብ ኣይከኣለን።",
      unreachable: "ናብ ሰርቨር ምብጻሕ ኣይተኻእለን። እንደገና ንምፍታን ነቲ ገጽ ኣሐድሶ።",
      no_token: "እዚ ታብ ድሕሪ ሕጂ ነቲ ፈተና ክመርሖ ኣይክእልን። ሓድሽ ክፍለ-ግዜ ንምጅማር Buzz ካብ ትምህርትኻ ክፈት።",
      taken_over: "እዚ ፈተና ሕጂ ካብ ካልእ ስክሪን ይምራሕ ኣሎ።",
      stale_question: "Buzz ኣብ እዋን እዚ ፈተና ተሓዲሱ፣ ስለዚ እዚ ስክሪን ክቕጽሎ ኣይክእልን። ካብቲ ክፍሊ ዘለዎ ቦታ ነቲ ፈተና ንምቕጻል ነቲ ገጽ ዳግማይ ጽዓኖ።",
      question_moved_on: "እቲ ፈተና ድሮ ቀጺሉ ኣሎ፣ ስለዚ እዚ ስክሪን ደንጒዩ ኣሎ። ካብቲ ክፍሊ ዘለዎ ቦታ ነቲ ፈተና ንምቕጻል ነቲ ገጽ ዳግማይ ጽዓኖ።",
    },
    entry: {
      opening: "መርኣያ መምህር ይኽፈት ኣሎ…",
      token_title: "እዚ ሊንክ መምህር ክኽፈት ኣይክእልን",
      token_body: "እቲ ሊንክ መፍትሕ መምህር የብሉን ወይ ግዜኡ ሓሊፉ። ሓድሽ ክፍለ-ግዜ ንምፍጣር Buzz ካብ ትምህርትኻ ክፈት።",
      not_found_title: "ክፍለ-ግዜ ኣይተረኽበን",
      not_found_body: "እዚ ክፍለ-ግዜ ፈተና ድሕሪ ሕጂ የለን። ንምቕጻል ሓድሽ ፍጠር።",
      back: "ናብ መጀመርታ ተመለስ",
    },
    questions: {
      drag_aria: "ንምስርዓቡ ዘርግሕ",
      remove_aria: "ሕቶ ኣውጽእ",
      empty: "ኣብዚ ክፍለ-ግዜ ሕቶታት የለዉን።",
      add: "ወስኽ",
      add_aria: "ሕቶ ወስኽ: {{text}}",
      add_all: "ኩሎም ወስኽ",
      add_all_n: "ኩሎም {{count}} ሕቶታት ወስኽ",
      more_one: "{{count}} ተወሳኺ ሕቶ ኣብዚ ትምህርቲ",
      more_other: "{{count}} ተወሳኺ ሕቶታት ኣብዚ ትምህርቲ",
      level_easy: "ቀሊል",
      level_medium: "ማእከላይ",
      level_hard: "ከቢድ",
      multi: "ብዙሕ ምርጫ",
    },
    lobby: {
      go_to: "ናብ <strong>buzz.binogi.com</strong> ኪድ ከምኡ ድማ ኣእቱ፥",
      or_qr: "…ወይ ኮድ QR ኣንብብ",
      students_joined_of: "{{joined}} ካብ {{expected}} ተምሃሮ ኣትዮም",
      students_joined_one: "{{count}} ተምሃራይ ኣትዩ",
      students_joined_other: "{{count}} ተምሃሮ ኣትዮም",
      waiting: "ተምሃሮ ክኣትዉ ይጽበ ኣሎ…",
      start_game: "ጸወታ ጀምር",
      connected: "ተራኺቡ",
      connecting: "ይራኸብ ኣሎ…",
      copy_link: "ሊንክ ቅዳሕ",
      copy_link_copied: "ተቐዲሑ!",
    },
    question: {
      header: "ሕቶ {{index}} ካብ {{total}}",
      level: "ደረጃ {{level}}",
      none: "ንጡፍ ሕቶ የለን።",
      answered: "መሊሶም",
      top_n: "ቀዳሞት {{count}}",
      answers_heading: "መልስታት",
      end_question: "ሕቶ ወድእ",
      next_question: "ቀጻሊ ሕቶ",
      see_results: "መወዳእታ ውጽኢት ርአ",
    },
    results: {
      heading: "መወዳእታ ውጽኢት",
      all_players: "ኩሎም ተጻወትቲ",
      end_session: "ክፍለ-ግዜ ወድእ",
      new_session: "ሓድሽ ክፍለ-ግዜ",
      none: "ኣብዚ ክፍለ-ግዜ ተጻወትቲ የለዉን።",
    },
  },
  join: {
    code_label: "ኮድ ጸወታ",
    name_label: "ስምካ",
    name_placeholder: "ስምካ ጽሓፍ",
    join_button: "እቶ",
    joining: "ይኣቱ ኣሎ…",
    checking: "ይምርመር ኣሎ…",
    character_hint: "ምስ ኣተኻ ዘዘናግዕ ስም ገጸ-ባህሪ Binogi ክትረክብ ኢኻ።",
    error_not_found:
      "እዚ ኮድ ገና ቀጥታዊ ክፍለ-ግዜ ኣይኮነን። ምስ መምህርካ ኣረጋግጾ።",
    error_lookup_failed: "ምድላይ ክፍለ-ግዜ ኣይተኻእለን",
    error_code_required: "እቲ ናይ 6-ፊደል ኮድ ኣእቱ።",
    error_name_required: "ስምካ ኣእቱ።",
  },
  play: {
    superseded: "ኣብ ካልእ ታብ ተራኺብካ ኣለኻ — ኣብዚ ንኽትቅጽል ዕጸዎ።",
    back_to_join: "ናብ ምእታው ተመለስ",
    no_round: "ሓበሬታ ዙር የለን።",
    not_joined: "ናብ ዝኾነ ክፍለ-ግዜ ኣይኣቶኻን።",
    no_question: "ንጡፍ ሕቶ የለን።",
    keep_awake_hint: "ስክሪን ከይጠፍእ ጠውቑ",
    waiting: {
      you_are: "ንስኻ ኢኻ",
      get_ready_named: "ተዳሎ፣ {{name}}!",
      get_ready: "ንፈተና ተዳሎ!",
      in_room_label: "ኣብ ክፍሊ ዘለዉ ተምሃሮ",
      in_room_one: "{{count}} ተምሃራይ ኣብ ክፍሊ ኣሎ",
      in_room_other: "{{count}} ተምሃሮ ኣብ ክፍሊ ኣለዉ",
    },
    question: {
      progress: "{{index}} / {{total}}",
      answered: "መሊስካ!",
      times_up: "ግዜ ኣኺሉ",
      submit: "ስደድ",
      submit_n: "{{count}} መልስታት ስደድ",
    },
    between: {
      correct: "ቅኑዕ!",
      wrong: "ቀረባ ኔራካ!",
      times_up: "ግዜ ኣኺሉ",
      points_gained: "+{{count}} ነጥብታት",
      your_score: "ነጥብኻ",
      your_rank: "ደረጃኻ፥ {{rank}}",
      top_n: "ቀዳሞት {{count}}",
      waiting_next: "ቀጻሊ ሕቶ ይጽበ ኣሎ…",
    },
    finished: {
      heading: "ብምጽዋት Binogi Buzz የቐንየልና!",
      your_final_rank: "መወዳእታ ደረጃኻ",
      top_n: "ቀዳሞት {{count}}",
      none: "ዝርአ ውጽኢት የለን።",
    },
  },
  characters: {
    heading: "ገጸ-ባህርያት Binogi",
    lead: "{{count}} ተምሃሮ ምስ ኣተዉ በዚ ቅደም ተኸተል ገጸ-ባህሪ ይወሃቦም።",
  },
};
